__turbopack_context__.v({
  "alignCenter": "verification-item-module-sass-module__X6oOOa__alignCenter",
  "block": "verification-item-module-sass-module__X6oOOa__block",
  "resendTxt": "verification-item-module-sass-module__X6oOOa__resendTxt",
  "successTxt": "verification-item-module-sass-module__X6oOOa__successTxt",
  "verifyBtn": "verification-item-module-sass-module__X6oOOa__verifyBtn",
  "verifyFormFields": "verification-item-module-sass-module__X6oOOa__verifyFormFields",
  "withMargin": "verification-item-module-sass-module__X6oOOa__withMargin",
  "wrongTxt": "verification-item-module-sass-module__X6oOOa__wrongTxt",
});
